import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=51098999&"
import script from "./transfer.vue?vue&type=script&lang=ts&"
export * from "./transfer.vue?vue&type=script&lang=ts&"
import style0 from "./transfer.vue?vue&type=style&index=0&id=51098999&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports